export const MINIMUM_PRESCRIBERS_LENGTH = 1;
export const MINIMUM_USERS_LENGTH = 0;
